const typeValues = [
  'REQUESTING',
  'REHYDRATE',
  'CLEAR_SUCCESS_ERROR_FLAGS',
  'RESET_DATA',
  'CHECK_LCI_CODE',
  'CHECK_LCI_CODE_SUCCESS',
  'CHECK_LCI_CODE_ERROR',
  'SET_JOIN_LCI_INFO',
  'JOIN_LCI',
  'JOIN_LCI_SUCCESS',
  'JOIN_LCI_ERROR',
  'GET_PROGRAMMING_LANGUAGE',
  'GET_PROGRAMMING_LANGUAGE_SUCCESS',
  'GET_PROGRAMMING_LANGUAGE_ERROR',
  'GET_CHALLENGE_WITH_PROBLEM',
  'GET_CHALLENGE_WITH_PROBLEM_SUCCESS',
  'GET_CHALLENGE_WITH_PROBLEM_ERROR',
  'GET_PROBLEM_FOR_CHALLENGE',
  'GET_PROBLEM_FOR_CHALLENGE_SUCCESS',
  'GET_PROBLEM_FOR_CHALLENGE_ERROR',
  'ADD_TRACK_CHALLENGE',
  'ADD_TRACK_CHALLENGE_SUCCESS',
  'ADD_TRACK_CHALLENGE_ERROR',
  'SET_LIVE_TOKEN',
  'CLEAR_LIVE_TOKEN',
  'ENDED_INTERVIEW',
  'INTERVIEWER_JOIN_ROOM',
  'CLEAR_LATEST_MESSAGE',
  'ALREADY_JOIN',
  'LOCAL_AUDIO_SWITCH',
  'LOCAL_VIDEO_SWITCH',
  'GET_LATEST_SUBMIT_INFO',
  'GET_LATEST_SUBMIT_INFO_SUCCESS',
  'GET_LATEST_SUBMIT_INFO_ERROR',
  'JOIN_SUCCESS',
  'MASTER_BROADCAST_AUDIO_DISABLED',
  'MASTER_BROADCAST_AUDIO_ENABLED',
  'AV_NOT_ALLOWED',
  'AV_NOT_AVAILABLE',
  'AV_ALLOWED',
  'CLEAR_AUTO_JOIN_IF_BACK',
  'BY_PASS_AUTO_JOIN_IF_BACK',
  'SOCKET_ERROR',
  'REMOTE_TRACK_STATE'
];

const types = typeValues.reduce((acc, curr) => { acc[curr] = curr; return { ...acc }; }, {});

export default types;
